import { Injectable } from '@angular/core';
import { MenuItem, ModifierDetail } from '@/core/models';
import { ModifierExtractorUtil } from './utils';

@Injectable({
	providedIn: 'root',
})
export class CartItemModifierProcessorService {
	/**
	 * Calcula los modificadores de un articulo
	 */
	public calculateMenuItemModifiers(menuItem: MenuItem, isAdd: boolean = true): ModifierDetail[] {
		const modifierDetailsWithQuantity = ModifierExtractorUtil.extractModifierDetails(
			menuItem,
			(detail: ModifierDetail) => !!((isAdd && detail?.addExtra) || (!isAdd && detail?.noAdd))
		);

		return modifierDetailsWithQuantity.map((item: ModifierDetail) => ({
			...item,
			id: item?.idDetalleModificador,
			nombre: item?.modificador?.nombre,
			cantidad: isAdd ? BigInt(item?.cantidad ?? 0n) : 0n,
			precio: isAdd ? BigInt(item?.precio ?? 0n) : 0n,
			precioBase: isAdd ? BigInt(item?.precioBase ?? 0n) : 0n,
			isFree: !!item?.isFree,
		}));
	}

	public calculateQuantityDisplay(detail: ModifierDetail): number {
		if (!detail?.cantidad) return 1;
		
		return Number(detail?.cantidad) + 1;
	}
}
